import { CurrencyFormatCheck } from './CurrencyFormate';
export const NumberFormat = (value, decimal, currencySymbol, wholeNumber) => {
    value = typeof value === 'string' ? value.replace(/,/g, '') : value;
    value =
        isNaN(parseInt(value)) || value === ''
            ? '-'
            : (currencySymbol ? currencySymbol : '₹') +
            new Intl.NumberFormat(
                CurrencyFormatCheck(currencySymbol),
                wholeNumber
                    ? {
                        style: 'decimal',
                        currency: 'INR',
                        minimumFractionDigits: 0, // No decimal places when wholeNumber is true
                        maximumFractionDigits: 0 // No decimal places when wholeNumber is true
                    }
                    : decimal
                        ? {
                            style: 'decimal',
                            currency: 'INR',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }
                        : {
                            style: 'decimal',
                            currency: 'INR'
                        }
            ).format(
                wholeNumber ? Math.round(Number(value)) : Number(value).toFixed(2)
            );
    if (value.includes('-')) {
        return '-' + value.replace(/-/g, '');
    }
    return value;
};